import { useState, useEffect } from "react";
import { CloudDownload, Loader2, Check, WifiOff } from "lucide-react";
import { toast } from "sonner";
import { prefetchAll } from "../lib/offline/sync";
import { getMeta, setMeta } from "../lib/offline/store";

export default function OfflinePrepCard() {
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState(0);
  const [ready, setReady] = useState(null); // { patients, at }

  useEffect(() => {
    getMeta("prefetch").then((v) => { if (v) setReady(v); }).catch(() => {});
  }, []);

  const run = async () => {
    if (!navigator.onLine) { toast.error("Conéctate a internet para preparar el modo sin conexión."); return; }
    setBusy(true); setProgress(0);
    try {
      const res = await prefetchAll((done, total) => setProgress(Math.round((done / total) * 100)));
      const info = { patients: res.patients, at: new Date().toISOString() };
      await setMeta("prefetch", info);
      setReady(info);
      toast.success(`Listo: ${res.patients} paciente(s) disponibles sin conexión.`);
    } catch {
      toast.error("No se pudo completar la descarga. Inténtalo de nuevo.");
    } finally { setBusy(false); setProgress(0); }
  };

  return (
    <div className="bg-white rounded-3xl p-5 border border-stone-100 shadow-[0_8px_30px_rgb(61,64,91,0.04)]" data-testid="offline-prep-card">
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-2xl bg-brand-sage/15 flex items-center justify-center shrink-0">
          <CloudDownload className="text-brand-sageDark" size={22} />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-outfit font-bold text-brand-ink">Trabajar sin internet</h3>
          <p className="text-sm text-muted-foreground mt-0.5">
            Descarga tus expedientes, consultas y vademécum para consultarlos sin conexión. Lo que crees o edites offline se subirá solo al reconectar.
          </p>
          {ready && !busy && (
            <p className="text-xs text-brand-sageDark font-semibold mt-2 flex items-center gap-1.5" data-testid="offline-prep-ready">
              <Check size={14} /> {ready.patients} paciente(s) listos · actualizado {new Date(ready.at).toLocaleString("es-MX")}
            </p>
          )}
          {busy && (
            <div className="mt-3">
              <div className="h-2 rounded-full bg-stone-100 overflow-hidden">
                <div className="h-full bg-brand-terracotta transition-all" style={{ width: `${progress}%` }} data-testid="offline-prep-progress" />
              </div>
              <p className="text-xs text-muted-foreground mt-1">{progress}%</p>
            </div>
          )}
          <button
            data-testid="offline-prep-btn"
            onClick={run}
            disabled={busy}
            className="mt-3 flex items-center gap-2 bg-brand-ink hover:opacity-90 text-white font-outfit font-semibold text-sm px-4 py-2.5 rounded-2xl transition-all disabled:opacity-60">
            {busy ? <><Loader2 size={16} className="animate-spin" /> Descargando…</> : <><CloudDownload size={16} /> {ready ? "Actualizar datos offline" : "Preparar para trabajar sin conexión"}</>}
          </button>
        </div>
      </div>
    </div>
  );
}
